// extracted by mini-css-extract-plugin
var _1 = "JMZh5hzQ1fP7kRSQqbbK";
var _2 = "Zzmz7ft4sj8RgMEsUxDK";
var _3 = "XKqqXQjcSLcUJ97hTSUf";
export { _1 as "header", _2 as "message", _3 as "root" }
